import styled from 'styled-components';

const FileItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;

export default FileItemContainer;
